import { useState } from "react"
import { Button, CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon } from "src/style"
// import { ReactComponent as PopupMsgIcon } from 'src/assets/img/msg-popup-icon.svg'
import { AppCenterPopupD2, CenterPopupHeaderD2 } from "src/component"
import { FiChevronDown } from "react-icons/fi"
import helpers, { getDateDifferenceInDays } from "src/utils/helpers"

export const ScheduleTransferD2: React.FC<any> = ({formData, handleInput, next, close}) => {

    function handleReminderDesabling (val: number): boolean {
        return formData.startDate && getDateDifferenceInDays(formData.startDate) <= val 
    }

    async function handleSchedule(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        next()
    }

    return (
        <AppCenterPopupD2 
            height={(formData.frequency === '1') ? '47' : formData.frequency ? '55.5' : '28'} 
            zIndex='6' overflow='hidden' 
            close={close}
        >
            <CenterPopupHeaderD2 title='Schedule Transfer' close={close} />
            <CustomContainer 
                height={(formData.frequency === '1') ? '47' : formData.frequency ? '55.5' : '28'}
                style={{maxHeight: '83.5%'}}
                className='popup-content-container'
            >
                <CustomContainer topMargin="2">
                    <Form onSubmit={handleSchedule} topMargin='2'>
                        <FormGroupWithIcon bottomMargin='2'>
                            <label>Frequency</label>
                            <div className="input-with-icon">
                                <select 
                                    name='frequency'
                                    value={formData.frequency}
                                    style={{color: formData.frequency ? '#000000' : '#667085'}}
                                    onChange={handleInput}
                                    required
                                >
                                    <option value="">Select Frequency</option>
                                    <option value="1">OneOff</option>
                                    <option value="2">Daily</option>
                                    <option value="3">Weekly</option>
                                    <option value="4">Monthly</option>
                                </select>
                                <FiChevronDown className="input-with-icon-tag" />
                            </div>
                        </FormGroupWithIcon>
                        { formData.frequency &&
                            <>
                                <FormGroup>
                                    <label>{formData.frequency == '1' ? 'Transfer' : 'Start'} Date</label>
                                    <input 
                                        placeholder='dd/mm/yyyy' 
                                        type='date'
                                        name='startDate'
                                        min={helpers.getInputValidDate()}
                                        style={{color: formData.startDate ? '#000000' : '#667085'}}
                                        value={formData.startDate}
                                        onChange={handleInput}
                                        autoComplete="off"
                                        required
                                    />
                                </FormGroup>
                                { formData.frequency != '1' &&
                                    <FormGroup>
                                        <label>End Date</label>
                                        <input 
                                            placeholder='dd/mm/yyyy' 
                                            type='date'
                                            name='endDate'
                                            min={helpers.getInputValidDate()}
                                            style={{color: formData.endDate ? '#000000' : '#667085'}}
                                            value={formData.endDate}
                                            onChange={handleInput}
                                            autoComplete="off"
                                            required
                                        />
                                    </FormGroup>
                                }
                                <FormGroupWithIcon bottomMargin='2'>
                                    <label>Reminder</label>
                                    <div className="input-with-icon">
                                        <select 
                                            name='reminder'
                                            value={formData.reminder}
                                            style={{color: formData.reminder ? '#000000' : '#667085'}}
                                            onChange={handleInput}
                                            required
                                        >
                                            <option value="">Select Reminder</option>
                                            <option 
                                                value="1" 
                                                disabled={handleReminderDesabling(1)} 
                                            >
                                                A day before
                                            </option>
                                            <option 
                                                value="2"
                                                disabled={handleReminderDesabling(2)} 
                                            >
                                                2 days before
                                            </option>
                                            <option 
                                                value="3"
                                                disabled={handleReminderDesabling(3)}
                                            >
                                                3 days before
                                            </option>
                                            <option 
                                                value="0" 
                                            >
                                                No reminder
                                            </option>
                                        </select>
                                        <FiChevronDown className="input-with-icon-tag" />
                                    </div>
                                </FormGroupWithIcon>
                            </>
                        }
                        <Button 
                            width='100' sizeUnit="%" height='4.4' 
                            borderColor='#0D968F' hoverBgColor='#fff' 
                            hoverColor='#0D968F'
                        >
                            Schedule
                        </Button>
                    </Form>
                </CustomContainer>
            </CustomContainer>
        </AppCenterPopupD2>
    )
}